import React, { Component, Fragment } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./AccountStyles";
import PopupWrapper from "../components/PopupWrapper";
import ApplianceListDisc from "../components/ApplianceListDisc";
import Spacer from "../components/Spacer";
import AccountSubheader from "../components/AccountSubheader";
import NumberStepper from "../components/NumberStepper";
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector, getFormValues } from "redux-form";
import Disc from "../components/Disc";
import Toggle from "react-toggle";
import Loading from "../components/Loading";
import { withCookies } from "react-cookie";
import { accountHomeViewActions } from "../_actions";
import { compose } from "redux";
import AccountBackButton from "../components/AccountBackButton";
import SuccessMessage from "../components/SuccessMessage";

const renderField = (props) => {
  const {
    input,
    label,
    type,
    meta: { touched, error, warning },
  } = props;

  const inputStyles = css([
    styles.input,
    touched && error && styles.inputError,
  ]);
  return (
    <div>
      <label className={css(styles.label)}>{label}</label>
      <div>
        <input
          {...input}
          placeholder={label}
          type={type}
          className={inputStyles}
        />
        {touched &&
          ((error && <span className={css(styles.error)}>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    </div>
  );
};
const renderRadio = (props) => {
  return (
    <span>
      <Disc
        size="small"
        icon={`${props.input.value}`}
        state={props.input.checked && "selected"}
      />
      <span className={css(styles.hidden)}>{props.label}</span>
      <input
        className={css(styles.hidden)}
        {...props.input}
        type={props.type}
      />
    </span>
  );
};
const renderToggleInput = (field) => (
  <Toggle
    checked={field.input.value}
    onChange={field.input.onChange}
    icons={false}
  />
);

class AccountHomeViewAppliance extends Component {
  constructor(props) {
    super(props);

    this.state = {
      applianceVisible: true,
    };
    this.handleToggle = this.handleToggle.bind(this);

    const user = JSON.parse(localStorage.getItem("user"));
    const user_id = JSON.parse(localStorage.getItem("user_id"));

    console.log("user before", user);
    console.log("user_id", user_id);
    const level = props.match.params.level;
    console.log("level", level);
    if (level == "infocare") {
      user.user_id = user.dependant_user_id;
    } else {
      user.user_id = user.user_id;
    }

    console.log("user after", user);

    this.props.dispatch(
      accountHomeViewActions.getAppliance(user, props.match.params.appliance_id)
    );
  }
  handleToggle(event) {
    this.setState({ applianceVisible: event.target.checked });
  }
  submit = (values) => {
    const user = JSON.parse(localStorage.getItem("user"));
    const level = this.props.match.params.level;
    if (level == "infocare") {
      user.user_id = user.dependant_user_id;
    }

    let obj = {
      appliance_type_id: this.props.match.params.appliance_id,
      ...values,
    };
    this.props.dispatch(accountHomeViewActions.setAppliance(user.user_id, obj));
  };

  render() {
    const {
      handleSubmit,
      submitSucceeded,
      accountHomeView: { fetchingDetail, detail },
    } = this.props;

    return (
      <div className={css(styles.container)}>
        <PopupWrapper />

        <header className={css(styles.header)}>
          <div className={css(styles.titleWrapper)}>
            <img
              src={"/icons/AccountIconLarge.svg"}
              className={css(styles.accountIcon)}
              alt=""
            />
            <h1 className={css(styles.title)}>Account</h1>
          </div>
          <AccountBackButton />
        </header>

        <main className={css(styles.mainContainer)}>
          <AccountSubheader
            backHref={`/account/${this.props.match.params.level}/appliances`}
            backLabel="Appliances"
            title={fetchingDetail ? "..." : detail.appliance_label}
          />
          {!submitSucceeded && detail.available_icons && (
            <>
              {fetchingDetail && <Loading />}

              {!fetchingDetail && detail.available_icons && (
                <form onSubmit={handleSubmit(this.submit)}>
                  <div className={css(styles.twoColumn)}>
                    <label
                      htmlFor="number_of_appliances"
                      className={css(styles.label)}
                    >
                      How many {detail.appliance_label} do you have?
                    </label>
                    <Field
                      name="number_of_appliances"
                      className={css(styles.input)}
                      component={NumberStepper}
                    />
                  </div>

                  {this.props.accountHomeViewForm &&
                    this.props.accountHomeViewForm.values.number_of_appliances >
                      0 && (
                      <div>
                        <Field
                          name="appliance_label"
                          component={renderField}
                          label="Appliance label"
                          type={"text"}
                        />
                        <Spacer />
                        <h4 className={css(styles.label)}>Appliance icon</h4>
                        <Spacer />
                        <div className={css(styles.applianceIconColumn)}>
                          {detail.available_icons !== undefined &&
                            detail.available_icons.map((icon, i) => {
                              return (
                                <label
                                  className={css(
                                    styles.applianceIconColumnItem
                                  )}
                                  key={i}
                                >
                                  <Field
                                    name="appliance_icon"
                                    component={renderRadio}
                                    type="radio"
                                    value={icon}
                                  />
                                </label>
                              );
                            })}
                        </div>

                        <Spacer />
                        <h4 className={css(styles.label)}>
                          Do you want to show this appliance?
                        </h4>
                        <Spacer />
                        <div className={css(styles.breakdownToggle)}>
                          <span className={css(styles.breakdownToggleUnit)}>
                            Hide
                          </span>
                          <label className={css(styles.breakdownToggleLabel)}>
                            <Field
                              name="show_appliance"
                              id="show_appliance"
                              component={renderToggleInput}
                            />
                          </label>
                          <span className={css(styles.breakdownToggleUnit)}>
                            Show
                          </span>
                        </div>
                      </div>
                    )}
                  <Spacer />
                  <Spacer />
                  <Spacer />
                  <Field
                    name="appliance_type_id"
                    component={renderField}
                    type="hidden"
                  />
                  <button type="submit" className={css(styles.buttonGreen)}>
                    Save Appliance
                  </button>
                </form>
              )}
            </>
          )}
          {!detail.available_icons && !fetchingDetail && (
            <SuccessMessage message={`${detail.appliance_label} saved`} />
          )}
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const initialValues = {
    number_of_appliances: state.accountHomeView.detail.number_of_appliances,
    appliance_label: state.accountHomeView.detail.appliance_label,
    appliance_icon: state.accountHomeView.detail.appliance_icon,
    show_appliance: state.accountHomeView.detail.show_appliance,
  };

  return {
    initialValues,
    accountHomeView: state.accountHomeView,
    ...state.form,
    // ...state.form
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "accountHomeViewForm",
    destroyOnUnmount: false,
    enableReinitialize: true,
  })(AccountHomeViewAppliance)
);
